import React, { useEffect, useState } from "react";
import { Table, Progress, message, ConfigProvider } from "antd";
import DashboardProvider from "../../../../../../shared/provider/DashboardProvider";
import { DashboardIdeaWithoutEvaluation } from "../../../../../../shared/dto/DashboardIdeaWithoutEvaluation";
import ptBR from "antd/lib/locale/pt_BR";

const columns = [
  {
    title: 'ID',
    dataIndex: 'ideaId',
    key: 'ideaId',
    sorter: (a: DashboardIdeaWithoutEvaluation, b: DashboardIdeaWithoutEvaluation) => a.ideaId - b.ideaId,
  },
  {
    title: 'Fase',
    dataIndex: 'stageName',
    key: 'stageName',
    sorter: (a: DashboardIdeaWithoutEvaluation, b: DashboardIdeaWithoutEvaluation) => a.stageName.localeCompare(b.stageName),
  },
  {
    title: 'Dias',
    dataIndex: 'daysWithoutEvaluation',
    key: 'daysWithoutEvaluation',
    sorter: (a: DashboardIdeaWithoutEvaluation, b: DashboardIdeaWithoutEvaluation) => a.daysWithoutEvaluation - b.daysWithoutEvaluation,
    render: (days: number) => {
      let color = '#1351b4'; // Blue
      if (days > 40) color = '#f8e111'; // Orange
      if (days > 60) color = '#ff0000'; // Red

      return (
        <Progress
          percent={(days / 60) * 100}
          size="small"
          strokeColor={color}
          format={() => `${days} dias`}
          style={{ width: 120 }}
        />
      );
    },
  },
];

function IdeasWithoutEvaluationList({ dataUpdater }: {dataUpdater: React.Dispatch<React.SetStateAction<DashboardIdeaWithoutEvaluation[]>>}): JSX.Element {
  const [data, setData] = useState<DashboardIdeaWithoutEvaluation[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const dashboardProvider = new DashboardProvider();
      try {
        const response = await dashboardProvider.getIdeasWithoutEvaluation();
        setData(response.slice(0, 10));
      } catch (error) {
        message.error("Erro ao buscar dados de ideias sem avaliação");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    dataUpdater(data);
  }, [data, dataUpdater]);

  return (
    <ConfigProvider locale={ptBR}>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        rowKey="ideaId"
        />
    </ConfigProvider>
  );
}

export default IdeasWithoutEvaluationList;
